import { Entity, ThemeExposure } from '@api';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { StepperSection } from '../components/stepper-section/StepperSection';
import { CompetitorsSection } from './components/competitors-section/CompetitorsSection';
import { RankSection } from './components/rank-section/RankSection';
import { SourceEvidenceSection } from './components/source-evidence-section/SourceEvidenceSection';
import styles from './ThemeExposureTab.module.scss';

interface ThemeExposureTabProps {
  entity: Entity;
  theme: ThemeExposure;
}

export const ThemeExposureTab = ({ entity, theme }: ThemeExposureTabProps) => {
  const { t } = useTranslation(['widget']);

  const { rank, description } = theme.relationship;

  const getComponentWithErrorBoundary = (child: ReactNode) => (
    <ErrorBoundaryWrapper>{child}</ErrorBoundaryWrapper>
  );

  return (
    <div className={styles.root}>
      <StepperSection
        entity={entity}
        theme={theme}
        title={t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.assetThemeExposure',
          {
            name: entity.name,
          }
        )}
        activeIndex={0}
        description={description}
      />
      <RankSection
        title={t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.rank'
        )}
        label={t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.current'
        )}
        rank={rank}
      />
      {getComponentWithErrorBoundary(
        <SourceEvidenceSection
          themeData={theme}
          source={POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW_DRAWER}
        />
      )}
      <div className={styles.horizontalDivider} />
      {getComponentWithErrorBoundary(
        <CompetitorsSection
          entityTag={entity.tag}
          themeId={theme.theme.id}
          themeName={theme.theme.name}
        />
      )}
    </div>
  );
};
